import React, { useState, useEffect, useRef } from "react";
// import { Link } from 'react-router-dom';
// import Logo from '../assets/img/ibridge-logo.png';
// import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import "../../assets/css/candidate-tab-form.css";
import _ from "lodash";
import "../../assets/css/inner-tabs.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABText from "../Common/ABText";
import ABUpload from "../Common/ABUpload";
import "../../assets/css/custom-modal.css";
import "../../assets/css/rec-carousel.css";
import { deleteSaveLicense, saveLicense } from "../../Actions/licenseAction";
import { getPincode } from "../../Actions/pincodeAction";
import ABUploadEdu from "../Common/ABUploadEdu";
import ABTextEdu from "./ABTextEdu";
import Loader from "../Common/loader";

const MainForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { license, active } = props;
  const reference = 291664278275;
  console.log(license);
  const [licenseData, setLicenseData] = useState([]);
  const [checksDetailsData, setChecksDetailsData] = useState([]);
  const [newRecord, setNewRecord] = useState({});
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [formError, setFormError] = useState({});
  const [documnetMandatory, setDocumnetMandatory] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  //const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    console.log(license);
    setLicenseData(license);
    // setCatchIfAnyStatusIsNotCompleted(0);
  }, [license]);

  useEffect(() => {
    // setLicenseData(license);
    //setCatchIfAnyStatusIsNotCompleted(0);
    if (
      licenseData.checksDetails !== "undefined" &&
      licenseData.checksDetails !== null
    ) {
      let activeTab = 0;
      // var tabs = document.getElementsByClassName('nav-link tab');
      // for (let i = 0; i < tabs.length; i++) {
      //   if (tabs[i].classList.contains("active")) {
      //     activeTab = tabs[i].dataset.index;

      //   }
      // }

      // alert(activeTab)

      setNewRecord({});

      // setChecksDetailsData(license.checksDetails);

      // let activeTab = null;
      // var tabs = document.getElementsByClassName("tab");
      // for (let i = 0; i < tabs.length; i++) {
      //   if (tabs[i].classList.contains("active")) {
      //     activeTab = tabs[i].dataset.index;
      //   }
      // }
      // console.log("sas".checksDetailsData);
      // const reRenderAgain = () => {
      //   props.reRenderAgain(licenseData);
      // };

      // const reRenderAgain2 = () => {

      //  props.reRenderAgain2();

      // };

      if (activeTab == 0) {
        Object.entries(license.checksDetails[0].fields).map(([key, value]) => {
          setNewRecord((prevState) => ({
            ...prevState,
            [value.id]: value.field_value,
          }));
        });
      }
    }
  }, [license, active]);

  console.log(licenseData);
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);

  useEffect(() => {
    if (
      typeof licenseData.checksDetails !== "undefined" &&
      licenseData.checksDetails !== null
    ) {
      console.log(licenseData.checksDetails);
      Object.entries(licenseData.checksDetails).map(([key, value]) => {
        console.log(value.check_status);
        if (value.check_status != 2) {
          setCatchIfAnyStatusIsNotCompleted(1);
        }
      });
    }
  }, [licenseData]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    console.log(checksDetails);
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
        console.log(count);
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  const getDocumentIdMandatory = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        obj[
          `${checksDetails[i].required_documents[j].id}`
        ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
      }
      uploadedFilesCount[i] = obj;
    }

    //alert(JSON.stringify(uploadedFilesCount));
    setDocumnetMandatory(uploadedFilesCount);

    //setRequired_documents
  };

  useEffect(() => {
    console.log("check", license);

    const checksDetails = license.checksDetails;
    console.log(checksDetails);
    getUploadedFilesCount(checksDetails);
    getDocumentIdMandatory(checksDetails);
  }, [license]);

  //  // setChecksDetailsLength(Object.keys(checksDetailsData).length);
  //   console.log(drugData);
  //   console.log(checksDetailsData);
  //  // console.log(checksDetailsLength);

  const selectHandler = (value) => {
    //this is state is for the purpose of storing data to the api
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    console.log(value);
    console.log(value[0].name);

    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    updateDetails(0, value[0].name, value[0].value);
    // if (newValidationRecord[value.name] === undefined || newValidationRecord[value.name] === null) {

    //     isError = false;
    //   }

    console.log(newValidationRecord);
    //this is state is for validation purpose

    //  let caseCheckId = value[0]['caseCheckId'];

    // console.log(Object.keys(checkDataRecord).includes(String(caseCheckId)));

    // if (!Object.keys(checkDataRecord).includes(String(caseCheckId))) {
    //   setCheckDataRecord((prevState) => ({
    //     ...prevState,
    //     [caseCheckId]: [],
    //   }));

    // }

    // setCheckDataRecord((prevState) => ({
    //   ...prevState,
    //   [caseCheckId]: [...prevState[caseCheckId], ...value],
    // }));

    //   console.log(newValidationRecord);
  };
  const updateDetails = (dataset, name, value) => {
    // alert(value);
    let details = _.cloneDeep(licenseData);

    console.log(details);
    console.log("l1", value);
    console.log("l12", details.checksDetails[0].fields[name].field_value);
    details.checksDetails[parseInt(dataset)].fields[name].field_value = value;

    setLicenseData(details);
    // console.log("ee", education);
  };

  const tabChange = (index, caseCheckId) => {
    if (
      typeof licenseData.checksDetails !== "undefined" &&
      licenseData.checksDetails !== null
    ) {
      if (caseCheckId) {
        navigate(
          `/case-initiation/check-detail/${reference}/12/${caseCheckId}`
        );
      }

      Object.entries(licenseData.checksDetails[index].fields).map(
        ([key, value]) => {
          setNewRecord((prevState) => ({
            ...prevState,
            [value.id]: value.field_value,
          }));
        }
      );
    }
  };

  const reRenderAgain = () => {
    props.reRenderAgain(licenseData);
  };

  const reRenderAgain2 = () => {
    props.reRenderAgain2();
  };

  //   useEffect(() => {
  //     if (
  //       typeof drugData.checksDetails !== "undefined" &&
  //       drugData.checksDetails !== null
  //     ) {

  //       //here find index of the tab with caseCheckId
  //       //finding which tab is active
  //       let foundIndex = null;
  //       var tabs = document.getElementsByClassName('nav-link tab');
  //       for (let i = 0; i < tabs.length; i++) {
  //         if (tabs[i].classList.contains("active")) {
  //           const dataCaseCh = tabs[i].dataset.casecheckid;
  //           if (dataCaseCh == active) {
  //             foundIndex = tabs[i].dataset.index;
  //           }

  //         }
  //       }
  //       // alert(foundIndex);
  //       if (active !== null && active !== undefined && foundIndex !== null) {
  //         tabChange(foundIndex, active);
  //       }
  //     }

  //   }, [drugData, active]);

  const formValidation = (caseCheckId, licenseData, activeTabIndex) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }

    let activeTab = activeTabIndex - 1;
    //finding which tab is active
    //  let activeTabCaseCheckId = null;
    // var tabs = document.getElementsByClassName('nav-link tab');
    // for (let i = 0; i < tabs.length; i++) {
    //   if (tabs[i].classList.contains("active")) {
    //     activeTab = tabs[i].dataset.index;
    //     activeTabCaseCheckId = tabs[i].dataset.caseCheckId;
    //   }
    // }

    // console.log(case_check_id);
    //finding which tab is active

    // console.log(education.checksDetails[0].fields.qualification_degree);

    let case_check_id = licenseData.checksDetails[activeTab].case_check_id;
    let field_course_name =
      licenseData.checksDetails[activeTab].fields.course_name;
    //checking if filed coming from api is mandatory
    if (field_course_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_course_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "course_name";
      console.log(elementName);
      let elementValue = newValidationRecord[elementName];

      console.log(elementErrorId);
      console.log(elementValue);
      let value_element = document.getElementById(
        "course_name_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" ||
        value_element.trim() == ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_institute_name =
      licenseData.checksDetails[0].fields.institute_name;
    //checking if filed coming from api is mandatory
    if (field_institute_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_institute_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "institute_name";
      let elementValue = newValidationRecord[elementName];
      let value_element = document.getElementById(
        "institute_name_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" ||
        value_element.trim() == ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_institute_location =
      licenseData.checksDetails[0].fields.institute_location;
    //checking if filed coming from api is mandatory
    if (field_institute_location.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_institute_location.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "institute_location";
      let elementValue = newValidationRecord[elementName];
      let value_element = document.getElementById(
        "institute_location_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" ||
        value_element.trim() == ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_license_number =
      licenseData.checksDetails[0].fields.license_number;
    //checking if filed coming from api is mandatory
    if (field_license_number.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_license_number.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "license_number";
      let elementValue = newValidationRecord[elementName];
      let value_element = document.getElementById(
        "license_number_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" ||
        value_element.trim() == ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }
    console.log(licenseData.checksDetails[0].required_documents[0].id);
    console.log(
      "document_" +
        licenseData.checksDetails[0].required_documents[0].id +
        "_count_" +
        case_check_id
    );
    let docCount = document.getElementById(
      "document_" +
        licenseData.checksDetails[0].required_documents[0].id +
        "_count_" +
        case_check_id
    ).value;
    console.log(docCount);
    if (docCount <= 0) {
      let elementErrorId =
        "err_document_" +
        licenseData.checksDetails[0].required_documents[0].id +
        "_count_" +
        case_check_id;

      document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      isError = true;
    }

    //  Object.entries(checkDataRecord).map(([key, value]) => {

    //   if(value.isRequired == 1){

    //   if (value.value === null) {
    //      errors.formVal1 = "This field is required.";
    //      document.getElementById(value.err_id).innerHTML = "This field is required.";
    //     //password.current.style.border = "1px solid red";
    //   } else {
    //     // password.current.style.border = "1px solid #E1E4EB";
    //   }

    //   }
    //   console.log(value);
    //   })

    return isError;
  };

  const saveHandler = (event, caseCheckId, licenseData, activetabIndex) => {
    event.preventDefault();
    console.log(caseCheckId);
    console.log(activetabIndex);
    console.log(newRecord[233]);
    console.log(event);
    const err = formValidation(caseCheckId, licenseData, activetabIndex);
    console.log(caseCheckId);

    console.log(err);
    if (err === true) {
      setFormError(err);

      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      const recordData = {};

      recordData.case_check_id = caseCheckId;

      const obj = {
        group: "prof_license",
        // "13": "12\/2014",
        // "69": "3",
        // "11": "3333",
        // "12": "",
        // "138": "test",
        // "52": "1",
        ...newRecord,
        // ...additonalData
      };
      console.log(obj);
      console.log(obj[70]);

      if (
        obj[235] != "" &&
        obj[236] != "" &&
        obj[237] != "" &&
        obj[238] != ""
      ) {
        //props.flag(1);
      }
      obj[235] = "Yes";

      // recordData.check_data = { [caseCheckId]: { "group": "education", ...newRecord, ...additonalData } };
      recordData.check_data = { [caseCheckId]: obj };
      //console.log(recordData);
      console.log(recordData);
      dispatch(saveLicense(recordData));
    }

    // reRenderAgain();
    // if(stateName!==undefined && activetabIndex==2){
    // navigate("/case-initiation/profile-preview/291662450924");
    // }
  };
  let emptyMandatory = true;
  if (license.checksDetails[0]) {
    Object.entries(license.checksDetails[0].fields).map(([key, value]) => {
      if (
        value.field_value == "" &&
        value.is_mandatory == 1 &&
        value.label == "Institute Name"
      ) {
        emptyMandatory = false;
      }
    });
    console.log(emptyMandatory);
  }
  const storeLicenseSave = useSelector((state) => state.licenseSave);
  const {
    licenseSaveData,
    loading: saveLoading,
    error: saveError,
  } = storeLicenseSave;
  console.log(licenseSaveData);
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //  reRenderAgain();
      }
    }
  }, [saveLoading]);
  useEffect(() => {
    if (typeof licenseSaveData !== "undefined" && licenseSaveData !== null) {
      // dispatch(get());
      // props.reSetData();
      reRenderAgain2();

      const hasNextCheck = licenseSaveData.nextCheck != "" ? true : false;
      // alert(hasNextCheck);
      //console.log(drugData.data.data.CaseStage)
      console.log(storeLicenseSave);
      //&& props.radioSelect=="Yes" && !emptyMandatory  !hasNextCheck &&
      // console.log("er", emptyMandatory[1].field_value);
      if (!hasNextCheck && emptyMandatory) {
        if (licenseSaveData.group.group_id != "profile_preview") {
          navigate(
            `/case-initiation/check-detail/${licenseData.referenceNo}/${licenseSaveData.group.group_id}`
          );
          dispatch(deleteSaveLicense());
        } else {
          navigate(
            `/case-initiation/profile-preview/${licenseData.referenceNo}`
          );
          dispatch(deleteSaveLicense());
        }
      } else if (licenseSaveData.nextCheck != undefined) {
        console.log(licenseSaveData.nextCheck);

        navigate(
          `/case-initiation/check-detail/${licenseSaveData.reference_number}/12/${licenseSaveData.nextCheck}`
        );
        dispatch(deleteSaveLicense());
        window.scrollTo(0, 0);
      }
    }
  }, [licenseSaveData, storeLicenseSave]);

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {checksDetailsData &&
            Object.entries(checksDetailsData).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;

              let activeClass = "";
              if (typeof active !== "undefined") {
                console.log(active + index);

                if (active == caseCheckId) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }
              let completeClass = "";
              console.log(caseCheckStatus);
              if (caseCheckStatus === 2) {
                completeClass = "completed";
              }

              return (
                <>
                  <li className={`nav-item ${completeClass}`} key={key}>
                    <a
                      className={`tab  ${activeClass} ${completeClass}`}
                      id={`licenseCheck-tab-${index}`}
                      data-toggle="tab"
                      href={`#licenseCheck-${index}`}
                      role="tab"
                      aria-controls={`licenseCheck-${index}`}
                      aria-selected="true"
                      data-index={index - 1}
                      data-caseCheckId={caseCheckId}
                      onClick={() => tabChange(key, caseCheckId)}
                    >
                      {/* {caseCheckStatus === 2 && (
                        <i class="fas fa-check-circle mr-1"></i>
                      )}
                      License Check {index} */}
                    </a>
                  </li>
                </>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {licenseData.checksDetails &&
          Object.entries(licenseData.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            //console.log(caseCheckId);

            //mapping needs to be checked need fields array here
            // console.log(value.fields[cisSlug]);

            let activeClass = "";
            if (typeof active !== "undefined") {
              console.log(active + index);

              if (active == caseCheckId) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }

            return (
              <>
                <div
                  className={`tab-pane fade ${activeClass}`}
                  id={`licenseCheck-${index}`}
                  role="tabpanel"
                  aria-labelledby={`license-tab-${index}`}
                  key={key}
                >
                  {/* <div className="d-flex justify-content-between align-items-center mb-3">
                  <span>
                    License Check-{`${index}`}
                  </span>  
                  </div>            */}
                  {/* <h6 className="fnt-smi-bld mb-3">
                  Do you have any qualification which requires licence to
                  practice like CA, doctor, lawer etc.
                </h6>
                <div className="row mb-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-check form-check-inline mr-4">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckYes"
                        value="Yes"
                        checked="true"
                      />
                      <label
                        htmlFor="referenceCheckYes"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckNo"
                        value="No"
                      />
                      <label
                        htmlFor="referenceCheckNo"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div> */}
                  <div className="row">
                    {value.fields.course_name ? (
                      <>
                        {console.log(caseCheckId)}

                        <ABTextEdu
                          label={value.fields.course_name.label}
                          //id={value.fields.course_name.check_id}
                          id={`course_name_${caseCheckId}`}
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.course_name.id}`}
                          caseId={caseCheckId}
                          inputText={selectHandler}
                          //maxLength="5"
                          fieldId={value.fields.course_name.ibridge_field_id}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          reRenderAgain={reRenderAgain}
                          // {newRecord[value.fields.address_sample_collection.ibridge_field_id]}
                          value={
                            newRecord[value.fields.course_name.ibridge_field_id]
                          }
                          name="course_name"
                        />
                        <p className="err text-danger">{formError.formVal1}</p>
                      </>
                    ) : (
                      <></>
                    )}

                    {value.fields.institute_name ? (
                      <>
                        <ABTextEdu
                          label={value.fields.institute_name.label}
                          //id={value.fields.institute_name.check_id}
                          id={`institute_name_${caseCheckId}`}
                          isRequired={1}
                          inputText={selectHandler}
                          //maxLength="5"
                          errId={`err_${caseCheckId}_${value.fields.institute_name.id}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.institute_name.ibridge_field_id}
                          name="institute_name"
                          reRenderAgain={reRenderAgain}
                          value={
                            newRecord[
                              value.fields.institute_name.ibridge_field_id
                            ]
                          }
                        />
                        {/* <p className="err text-danger">{formError.formVal1}</p> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="row">
                    {value.fields.institute_location ? (
                      <>
                        {console.log(
                          newRecord[
                            value.fields.institute_location.ibridge_field_id
                          ]
                        )}
                        <ABTextEdu
                          label={value.fields.institute_location.label}
                          // id={value.fields.institute_location.check_id}
                          id={`institute_location_${caseCheckId}`}
                          errId={`err_${caseCheckId}_${value.fields.institute_location.id}`}
                          caseId={caseCheckId}
                          fieldId={
                            value.fields.institute_location.ibridge_field_id
                          }
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          isRequired={1}
                          licenseIndex={key}
                          // maxLength="5"
                          reRenderAgain={reRenderAgain}
                          value={
                            newRecord[
                              value.fields.institute_location.ibridge_field_id
                            ]
                          }
                          inputText={selectHandler}
                          name="institute_location"
                        />

                        <p className="err text-danger">{formError.formVal1}</p>
                      </>
                    ) : (
                      <></>
                    )}
                    {value.fields.license_number ? (
                      <>
                        <ABTextEdu
                          label={value.fields.license_number.label}
                          // id={value.fields.license_number.check_id}
                          id={`license_number_${caseCheckId}`}
                          isRequired={1}
                          inputText={selectHandler}
                          errId={`err_${caseCheckId}_${value.fields.license_number.id}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.license_number.ibridge_field_id}
                          name="license_number"
                          checkDetailsIndex={key}
                          reRenderAgain={reRenderAgain}
                          // maxLength="5"
                          value={
                            newRecord[
                              value.fields.license_number.ibridge_field_id
                            ]
                          }
                        />
                        <p className="err text-danger">{formError.formVal1}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <h6 className="fnt-smi-bld mb-0">Upload File</h6>
                  <small className="text-muted">Upload related documents</small>
                  {value.required_documents ? (
                    <>
                      {console.log(value.required_documents.id)}
                      <ABUploadEdu
                        name={value.required_documents[0].id}
                        id={value.required_documents[0].id}
                        title={value.required_documents[0].document_name}
                        record={{
                          caseCheckId: caseCheckId,
                          docId: value.required_documents[0].id,
                        }}
                        totalCount={
                          uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][
                            value.required_documents[0].id
                          ]
                            ? uploadedFilesCount[parseInt(index - 1)][
                                value.required_documents[0].id
                              ]
                            : 0
                        }
                        // errId={`err_${caseCheckId}_${value.fields.is_document_provided.id}`}
                        isRequired={1}
                        // getCount={1}
                        reRenderAgain={reRenderAgain}
                      />
                      <input
                        type="hidden"
                        name={`document_${value.required_documents[0].id}_count_${caseCheckId}`}
                        id={`document_${value.required_documents[0].id}_count_${caseCheckId}`}
                        value={
                          uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][
                            value.required_documents[0].id
                          ]
                            ? uploadedFilesCount[parseInt(index - 1)][
                                value.required_documents[0].id
                              ]
                            : 0
                        }
                      />
                      <p
                        className="err text-danger"
                        id={`err_document_${value.required_documents[0].id}_count_${caseCheckId}`}
                      ></p>
                      {/* <p className="err text-danger">{formError.formVal1}</p> */}
                    </>
                  ) : (
                    <></>
                  )}

                  {/* {value.fields.preffered_mode_collection ?

                <ABText
                label={value.fields.label}
                id={value.fields.check_id}
                name="Preffered Mode of Collection" />


                : <></>
                } */}

                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                        Back
                      </button> */}
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) =>
                          saveHandler(e, caseCheckId, licenseData, index)
                        }
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                {licenseData.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </>
            );
          })}
      </div>
      {/* 
            <div className={`tab-pane fade ${activeClass}`} id={`education-${index}`} role="tabpanel" aria-labelledby={`education-tab-${index}`} key={key}>
            </div>
            </div> */}
    </>
  );
};

export default MainForm;
